<template>
  <div class="video-content">
    <div class="video-content-fixed">
      <div class="video-title">
        <div class="title">KeyPal</div>
        <img src="../../assets/images/keypal-two/two.png" alt="" />
      </div>
      <div class="video-desc">
        {{ $t('keypalTwo.video.desc') }}
      </div>
      <div class="buttons">
        <div class="button" @click="onButton(0)">{{ $t('keypalTwo.video.preOrderNow') }}</div>
        <div class="button watch-btn" @click="onButton(1)">
          <img :src="watchIcon" alt="" />
          <span>{{ $t('keypalTwo.video.watchNow') }}</span>
        </div>
      </div>
    </div>
    <div class="video-wrap" v-if="!isMobileSize">
      <video
        id="video"
        :src="videoUrl"
        autoplay
        muted
        x5-video-player-fullscreen="true"
        x5-video-player-type="h5"
        playsinline="true"
        webkit-playsinline="true"
      ></video>
    </div>
    <div class="mobile-bg" v-else>
      <img src="../../assets/images/keypal-two/mobile-bg.png" alt="" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['isMobileSize']),
    videoUrl() {
      return `https://hk.tpstatic.net/keypal-2/main${this.darkModeImg}.mp4?version=2`;
    },
    watchIcon() {
      return require(`./../../assets/images/keypal-two/play${this.darkModeImg}.png`);
    },
  },
  methods: {
    onButton(type) {
      if (type === 0) {
        let url = `https://www.keypal.store/products/keypal-2`;
        if (this.$i18n.locale === 'zh') {
          url = `https://j.youzan.com/bgv9dO`
        }
        window.open(url, '_blank');
      } else if (type === 1) {
        this.$emit('playVideo');
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.video-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  .video-wrap {
    width: 100%;
    font-size: 0;
    background: var(--bg-3);
    #video {
      display: block;
      min-height: 240px;
      width: 100%;
      height: 100%;
    }
  }


  .video-content-fixed {
    padding-top: 72px;
    width: 100%;
    background: var(--bg-3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .video-title {
      display: flex;
      align-items: center;
      gap: 0 32px;

      .title {
        font-size: 96px;
        font-weight: 600;
        color: var(--color-1);
      }

      img {
        width: 76px;
        height: 76px;
      }
    }

    .video-desc {
      margin-top: 24px;
      font-size: 27px;
      color: var(--color-1);
      text-align: center;
    }

    .buttons {
      margin-top: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0 15px;
      .button {
        display: flex;
        align-items: center;
        gap: 0 8px;
        height: 56px;
        line-height: 56px;
        background: #2980fe;
        border-radius: 38px;
        padding: 0 30px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
      }

      .watch-btn {
        display: flex;
        align-items: center;
        gap: 0 8px;
        border: 1px solid var(--border-1);
        background: var(--bg-3);
        color: var(--color-1);
        img {
          width: 26px;
          height: 26px;
        }
      }
    }
  }
}

@media screen and (max-width: 1700px) {
  .video-content {
    .video-content-fixed {
      top: 50px;
    }
  }
}

@media screen and (max-width: 1530px) {
  .video-content {
    .video-content-fixed {
      top: 30px;
    }
  }
}

@media screen and (max-width: 767px) {
  .video-content {
    .video-wrap {
      #video {
        min-height: 200px;
      }
    }
    .video-content-fixed {
      padding-top: 32px;
      top: 50px;
      .video-title {
        gap: 0 12px;
        .title {
          font-size: 56px;
          text-align: center;
        }
        
        img {
          width: 40px;
          height: 40px;
        }
      }
      .video-desc {
        margin-top: 10px;
        font-size: 16px;
      }
      .buttons {
        margin-top: 16px;
        gap: 12px;
        .button {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          padding: 0 20px;
        }
        .watch-btn {
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    .mobile-bg {
      margin-top: 24px;
      font-size: 0;
      background: var(--bg-3);
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
